function initDiscountPopup() {
  const widget = document.getElementById("discount-widget");
  const popup = document.getElementById("discount-popup");

  if (!widget || !popup) {
    return;
  }

  const closeButton = popup.querySelector(".discount-popup__close");
  const overlay = popup.querySelector(".discount-popup__overlay");
  /** @type {HTMLElement | null} */
  const noThanks = popup.querySelector(".discount-popup__no-thanks");

  /** @type {HTMLFormElement | null} */
  const form = popup.querySelector(".discount-popup__form");

  /** @type {HTMLInputElement | null} */
  const emailInput = popup.querySelector("input[type='email']");

  /** @type {HTMLButtonElement | null} */
  const submitButton = popup.querySelector(".discount-popup__submit");

  /** @type {HTMLElement | null} */
  const captchaContainer = popup.querySelector(".discount-popup__captcha");

  /** @type {HTMLElement | null} */
  const errorEl = popup.querySelector(".discount-popup__error");

  /** @type {HTMLElement | null} */
  const successEl = popup.querySelector(".discount-popup__success");

  const shop = popup.getAttribute("data-shop") || "";
  const apiBase = popup.getAttribute("data-api-base") || "";

  const signupCookie = "retenzy_discount_signup";
  const signupPointsKey = "retenzy_signup_points";

  /** @param {string} name */
  function getCookie(name) {
    try {
      const match = document.cookie.match(
        new RegExp("(?:^|; )" + name + "=([^;]*)")
      );

      return match && match[1] ? decodeURIComponent(match[1]) : "";
    } catch {
      return "";
    }
  }

  /** @param {string} name @param {string} value @param {number} days */
  function setCookie(name, value, days) {
    try {
      const expires = new Date(
        Date.now() + days * 24 * 60 * 60 * 1000
      ).toUTCString();

      document.cookie =
        name +
        "=" +
        encodeURIComponent(value) +
        "; expires=" +
        expires +
        "; path=/; SameSite=Lax";
    } catch {
      // ignore cookie errors
    }
  }

  /*
   * If this visitor already signed up, never show the
   * offer again on this store. Stored in a cookie so it
   * resets when cookies are cleared.
   */
  const alreadySignedUp = getCookie(signupCookie) === "1";

  if (alreadySignedUp) {
    widget.style.display = "none";
    return;
  }

  const w = /** @type {any} */ (window);

  const SUBMIT_LABEL = "I AM HAPPY TO RECEIVE UPTO 15% OFF";

  let turnstileToken = "";
  /** @type {string | null} */
  let turnstileWidgetId = null;
  let turnstileReady = false;
  let captchaFailed = false;

  let siteKey = "";
  let configReady = false;
  let configError = "";

  let submitting = false;

  /** @type {Promise<any> | null} */
  let turnstileScriptPromise = null;

  /** @type {Promise<void> | null} */
  let renderPromise = null;


  /* =========================
     UI HELPERS
  ========================= */

  /** @param {string} message */
  function showError(message) {
    if (!errorEl) {
      return;
    }

    errorEl.textContent = message;
    errorEl.hidden = !message;
  }


  /** @param {boolean} isLoading */
  function setLoading(isLoading) {
    submitting = isLoading;

    if (submitButton) {
      submitButton.disabled = isLoading;

      submitButton.textContent = isLoading
        ? "SIGNING UP..."
        : SUBMIT_LABEL;
    }
  }


  /** @param {{ customer_id?: unknown, exp?: unknown, email?: unknown } | undefined} data */
  function showSuccess(data) {
    if (form) {
      form.hidden = true;
    }

    if (noThanks) {
      noThanks.hidden = true;
    }

    if (successEl) {
      successEl.hidden = false;
    }

    /*
     * Remember the signup (in a cookie) so the offer does
     * not reappear after a refresh.
     */
    setCookie(signupCookie, "1", 365);

    /*
     * Share the Retenzy session with the reward widget.
     * The widget reads `retenzy_extn_user` from localStorage
     * ({ email, customer_id, exp }) to load the customer.
     */
    try {
      if (data && data.customer_id) {
        window.localStorage.setItem(
          "retenzy_extn_user",
          JSON.stringify({
            email: data.email,
            customer_id: data.customer_id,
            exp: data.exp
          })
        );
      }
    } catch {
      // ignore storage errors (private mode, etc.)
    }

    if (widget) {
      widget.style.display = "none";
    }

    saveSignupPoints();

    /*
     * Refresh the page so the reward widget and other
     * sections pick up the new customer session.
     */
    window.setTimeout(function () {
      window.location.reload();
    }, 1500);
  }


  /*
   * Fetch the store's signup points (from the Retenzy earn rules)
   * and cache the value in localStorage.
   */
  async function saveSignupPoints() {
    if (!apiBase || !shop) {
      return;
    }

    try {
      const response = await fetch(
        `${apiBase}/get-all-reward?shop=${encodeURIComponent(shop)}`
      );

      const json = await response.json();
      const rules = (json && json.data) || [];

      const signupRule = rules.find(function (/** @type {any} */ rule) {
        return rule && rule.rule_type === "signup";
      });

      if (signupRule && signupRule.point != null) {
        window.localStorage.setItem(
          signupPointsKey,
          String(signupRule.point)
        );
      }
    } catch {
      // ignore errors fetching/caching signup points
    }
  }


  function resetCaptcha() {
    turnstileToken = "";

    const turnstile = w.turnstile;

    if (turnstile && turnstileWidgetId != null) {
      try {
        turnstile.reset(turnstileWidgetId);
      } catch {
        // ignore reset failures
      }
    }

    captchaFailed = false;

    updateCaptchaVisibility();
  }


  /*
   * Non-interactive widgets pass silently: valid token, no
   * iframe, no visible checkbox. Show our own spinner while
   * verification is pending, collapse the empty box once it
   * passes. If Cloudflare later injects an iframe
   * (challenge/spinner), the box reappears with its UI.
   */
  function updateCaptchaVisibility() {
    if (!captchaContainer) {
      return;
    }

    const hasFrame = Boolean(
      captchaContainer.querySelector("iframe")
    );

    let hasToken = Boolean(turnstileToken);

    if (!hasToken) {
      try {
        const ts = w.turnstile;

        hasToken = Boolean(
          ts &&
          typeof ts.getResponse === "function" &&
          turnstileWidgetId != null &&
          ts.getResponse(turnstileWidgetId)
        );
      } catch {
        hasToken = false;
      }
    }

    captchaContainer.classList.toggle(
      "is-silent",
      !hasFrame && hasToken
    );

    if (captchaSpinner) {
      captchaSpinner.hidden =
        hasFrame || hasToken || captchaFailed;
    }
  }


  if (
    captchaContainer &&
    typeof MutationObserver !== "undefined"
  ) {
    new MutationObserver(function () {
      updateCaptchaVisibility();
    }).observe(captchaContainer, {
      childList: true,
      subtree: true
    });
  }


  /*
   * Custom "verifying" indicator. Inserted up front so it is
   * visible while the Turnstile script loads and while a
   * non-interactive check runs with no Cloudflare UI.
   */
  /** @type {HTMLElement | null} */
  let captchaSpinner = null;

  if (captchaContainer) {
    captchaSpinner = document.createElement("div");
    captchaSpinner.className = "discount-popup__spinner";
    captchaSpinner.setAttribute("aria-hidden", "true");
    captchaSpinner.hidden = true;

    const ring = document.createElement("span");
    ring.className = "discount-popup__spinner-ring";
    ring.setAttribute("aria-hidden", "true");

    const label = document.createElement("span");
    label.className = "discount-popup__spinner-text";
    label.textContent = "Verifying you are human…";

    captchaSpinner.appendChild(ring);
    captchaSpinner.appendChild(label);
    captchaContainer.appendChild(captchaSpinner);
  }


  /* =========================
     OPEN POPUP
  ========================= */

  const openPopup = async function () {
    popup.classList.add("is-visible");

    popup.setAttribute(
      "aria-hidden",
      "false"
    );

    document.body.style.overflow = "hidden";

    showError("");

    /*
     * Load Retenzy configuration only when
     * the popup is opened.
     */
    if (!configReady) {
      await loadConfig();
    }

    /*
     * Render CAPTCHA after the popup is visible.
     */
    if (configReady) {
      await renderCaptcha();
    }
  };


  /* =========================
     CLOSE POPUP
  ========================= */

  const closePopup = function () {
    popup.classList.remove("is-visible");

    popup.setAttribute(
      "aria-hidden",
      "true"
    );

    document.body.style.overflow = "";
  };


  /* =========================
     TURNSTILE SCRIPT
  ========================= */

  function loadTurnstileScript() {
    if (turnstileScriptPromise) {
      return turnstileScriptPromise;
    }

    if (w.turnstile) {
      turnstileScriptPromise = Promise.resolve(
        w.turnstile
      );

      return turnstileScriptPromise;
    }

    turnstileScriptPromise = new Promise(
      function (resolve, reject) {
        const script = document.createElement("script");

        script.src =
          "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

        script.async = true;
        script.defer = true;

        script.onload = function () {
          if (w.turnstile) {
            resolve(w.turnstile);
          } else {
            reject(
              new Error(
                "Verification widget failed to initialize."
              )
            );
          }
        };

        script.onerror = function () {
          turnstileScriptPromise = null;

          reject(
            new Error(
              "Failed to load the verification widget."
            )
          );
        };

        document.head.appendChild(script);
      }
    );

    return turnstileScriptPromise;
  }


  /* =========================
     LOAD RETENZY CONFIG
  ========================= */

  async function loadConfig() {
    if (!shop || !apiBase) {
      configError =
        "Sign up is unavailable right now.";

      return;
    }

    try {
      const response = await fetch(
        `${apiBase}/api/get-login-setup?shop=${encodeURIComponent(shop)}`
      );

      const json = await response.json();

      const setup =
        json && json.data
          ? json.data
          : json;

      const credential =
        setup && setup.credential
          ? setup.credential
          : null;

      siteKey =
        credential && credential.site_key
          ? credential.site_key
          : "";

      if (
        !response.ok ||
        !setup ||
        setup.method !== "captcha" ||
        !siteKey
      ) {
        configError =
          (json && json.message) ||
          "Verification is not configured for this store.";

        configReady = false;

        return;
      }

      configReady = true;
      configError = "";

    } catch (error) {
      configReady = false;

      configError =
        error instanceof Error
          ? error.message
          : "Sign up is unavailable right now.";
    }
  }


  /* =========================
     RENDER CAPTCHA
  ========================= */

  function renderCaptcha() {
    /*
     * Don't blindly trust turnstileReady.
     *
     * The popup can recreate/replace its DOM while the old
     * Turnstile widget ID is still stored in JavaScript.
     */
    if (turnstileReady && turnstileWidgetId != null) {
    const existingWidget =
      captchaContainer?.querySelector(
        'iframe[src*="challenges.cloudflare.com"]'
      );

    /*
     * If the widget is still present, we're done.
     */
    if (existingWidget) {
      console.log(
        "[Turnstile] Existing widget is still present."
      );

      return Promise.resolve();
    }

    /*
     * The ID exists, but the visual widget is gone.
     * Reset our local state so we can render again.
     */
    console.warn(
      "[Turnstile] Stale widget ID detected. Re-rendering."
    );

    turnstileReady = false;
    turnstileWidgetId = null;
    turnstileToken = "";
  }

  if (renderPromise) {
    return renderPromise;
  }

  if (
    !configReady ||
    !siteKey ||
    !captchaContainer ||
    !popup?.classList.contains("is-visible")
  ) {
    return Promise.resolve();
  }

  captchaFailed = false;
  updateCaptchaVisibility();

  renderPromise = loadTurnstileScript()
    .then(function (/** @type {any} */ turnstile) {      if (!turnstile) {
        throw new Error(
          "Verification is unavailable right now."
        );
      }

      /*
       * Another call may have rendered the widget while the
       * Turnstile script was loading.
       */
      if (turnstileWidgetId != null) {
        console.log(
          "[Turnstile] Widget already exists:",
          turnstileWidgetId
        );

        return;
      }

      console.log(
        "[Turnstile] Rendering widget..."
      );

      turnstileWidgetId = turnstile.render(
        captchaContainer,
        {
          sitekey: siteKey,

          size: "normal",

          theme: "auto",

          appearance: "always",

          retry: "auto",

          "refresh-expired": "auto",

          callback: function (
            /** @type {string} */ token
          ) {
            console.log(
              "[Turnstile] Token received"
            );

            turnstileToken = token;

            showError("");

            updateCaptchaVisibility();
          },

          "expired-callback": function () {
            console.log(
              "[Turnstile] Token expired"
            );

            turnstileToken = "";

            updateCaptchaVisibility();
          },

          "error-callback": function () {
            console.error(
              "[Turnstile] Verification error"
            );

            turnstileToken = "";

            updateCaptchaVisibility();

            showError(
              "Verification failed. Please try again."
            );
          },

          "unsupported-callback": function () {
            console.error(
              "[Turnstile] Browser unsupported"
            );

            showError(
              "Verification is not supported in this browser."
            );
          }
        }
      );

      console.log(
        "[Turnstile] Widget rendered:",
        turnstileWidgetId
      );

      turnstileReady = true;

      updateCaptchaVisibility();
    })
    .catch(function (error) {
      console.error(
        "[Turnstile] Render failed:",
        error
      );

      turnstileReady = false;
      turnstileWidgetId = null;
      turnstileToken = "";
      captchaFailed = true;

      updateCaptchaVisibility();

      showError(
        error instanceof Error
          ? error.message
          : "Failed to load the verification widget."
      );
    })
    .finally(function () {
      renderPromise = null;
    });

  return renderPromise;
}

  /* =========================
     GET 15% OFF
  ========================= */

  widget.addEventListener(
    "click",
    openPopup
  );


  /* =========================
     CLOSE BUTTON
  ========================= */

  if (closeButton) {
    closeButton.addEventListener(
      "click",
      closePopup
    );
  }


  /* =========================
     CLICK OUTSIDE
  ========================= */

  if (overlay) {
    overlay.addEventListener(
      "click",
      closePopup
    );
  }


  /* =========================
     NO THANKS
  ========================= */

  if (noThanks) {
    noThanks.addEventListener(
      "click",
      closePopup
    );
  }


  /* =========================
     SIGN UP
  ========================= */

  if (form) {
    form.addEventListener(
      "submit",
      async function (event) {
        event.preventDefault();

        if (submitting) {
          return;
        }

        showError("");

        const email =
          emailInput
            ? emailInput.value.trim()
            : "";

        /*
         * Validate email.
         */
        if (!email) {
          showError(
            "Please enter your email."
          );

          return;
        }

        /*
         * Configuration must be loaded.
         */
        if (!configReady) {
          showError(
            configError ||
            "Verification is not available right now."
          );

          return;
        }

        /*
         * Make sure CAPTCHA exists.
         */
        if (!turnstileReady) {
          await renderCaptcha();
        }

        if (!turnstileReady) {
          showError(
            "Please wait for the verification to load."
          );

          return;
        }

        /*
         * User must complete CAPTCHA.
         *
         * Fall back to getResponse() — the Cloudflare callback
         * can be missed (e.g. widget auto-solved before our
         * callback attached), while the widget itself already
         * holds a valid token.
         */
        if (!turnstileToken) {
          try {
            const ts = w.turnstile;

            if (
              ts &&
              typeof ts.getResponse === "function" &&
              turnstileWidgetId != null
            ) {
              turnstileToken = ts.getResponse(turnstileWidgetId) || "";
            }
          } catch {
            // ignore fallback failures
          }
        }

        if (!turnstileToken) {
          showError(
            "Please complete the verification."
          );

          return;
        }

        setLoading(true);

        try {
          const response = await fetch(
            `${apiBase}/auth/customer/verify-captcha?shop=${encodeURIComponent(shop)}`,
            {
              method: "POST",

              headers: {
                "Content-Type": "application/json"
              },

              body: JSON.stringify({
                email: email,
                token: turnstileToken,
                phone: null
              })
            }
          );

          const json =
            await response.json();

          if (
            !response.ok ||
            !json ||
            !json.data ||
            !json.data.customer_id
          ) {
            throw new Error(
              (json && json.message) ||
              "Sign up failed. Please try again."
            );
          }

          /*
           * Customer successfully created/found.
           */
          showSuccess(json.data);

        } catch (error) {
          showError(
            error instanceof Error
              ? error.message
              : "Sign up failed. Please try again."
          );

          resetCaptcha();

        } finally {
          setLoading(false);
        }
      }
    );
  }


  /*
   * Auto-open the popup once, 5 seconds after the page loads.
   * It will not reappear while the visitor stays on the page;
   * a page refresh (or a new visit) shows it again. It also
   * stops once the visitor has signed up (signup cookie set
   * in showSuccess()).
   */
  let autoOpenHandled = false;

  window.setTimeout(function () {
    if (autoOpenHandled) {
      return;
    }

    autoOpenHandled = true;

    openPopup();
  }, 5000);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initDiscountPopup);
} else {
  initDiscountPopup();
}